"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefProgramPopUpContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.RefProgramPopUpContent = styled_components_1.default.form `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 50px;
  gap: 32px;
  margin: 0;
`;
